export default __webpack_public_path__ + "static/media/ap logo.a6dac3b8.png";